import { render, staticRenderFns } from "./file-download.vue?vue&type=template&id=df394544&scoped=true&"
import script from "./file-download.vue?vue&type=script&lang=js&"
export * from "./file-download.vue?vue&type=script&lang=js&"
import style0 from "./file-download.vue?vue&type=style&index=0&id=df394544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df394544",
  null
  
)

export default component.exports